import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Modal from "react-bootstrap/Modal";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { appConstants } from "../../../redux/action-constants/inapp.constants";
import LeftArrow from "../../../assets/left-arr.png";
import { AlertBanner } from "../../../shared/components/alert-banner";
import { useState, useEffect } from "react";

const VerifyInfo = ({
  pageProps,
  payoutType,
  tokenRequest,
  cardtokenizedData,
  storeFormInitValues,
  ownerAddressSearched,
  setCardTokenized,
  createTokenizeData,
  ipAddress,
  handleSelectedOwnerAddress,
  setNewPostalCode,
  createPayoutAccAction,
  setPayoutAccountData,
  getStorePayAccounts,
}: any) => {
  const detailsValidationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    phone: Yup.string().required("Required"),
    postalCode: Yup.string().required("Required"),
    addressLine1: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
  });

  const [successMessage, setSuccessMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  // Reset messages on component mount
  useEffect(() => {
    setSuccessMessage("");
    setErrorMessage("");
  }, []);

  useEffect(() => {
    if (
      pageProps.createStorePayoutRequest.request_status ===
      "CREATE_PAYOUT_ACCOUNT_SUCCESS"
    ) {
      const responseLink =
        pageProps.createStorePayoutRequest?.request_data?.response?.link;

      setSuccessMessage("Account added successfully!");
      setErrorMessage("");

      if (responseLink) {
        setTimeout(() => {
          window.location.href = responseLink;
        }, 2000);
        setSuccessMessage("Redirecting to payout setup...");
      }

      // Check for specific error status and detail
      if (
        pageProps.createStorePayoutRequest.request_data?.response?.status ===
          409 &&
        pageProps.createStorePayoutRequest.request_data?.response?.detail
      ) {
        setSuccessMessage("");
        setErrorMessage(
          pageProps.createStorePayoutRequest.request_data?.response?.detail
        );
      }

      setTimeout(() => {
        let loggedAccountInfo: any =
          localStorage.getItem("mamiVendorXAuth") || "{}";
        loggedAccountInfo = JSON.parse(loggedAccountInfo);
        if (!loggedAccountInfo.selectedStore?.id) {
          console.error(
            "No store ID found after success, cannot refresh accounts"
          );
          setErrorMessage("No store selected. Please select a store.");
          return;
        }
        let payload = `Page=1&Size=10&StoreId=${loggedAccountInfo.selectedStore.id}`;
        getStorePayAccounts({ pageProps, payload });
      }, 2000);
    } else if (
      pageProps.createStorePayoutRequest.request_status ===
      "CREATE_PAYOUT_ACCOUNT_FAILURE"
    ) {
      setErrorMessage(
        pageProps.createStorePayoutRequest?.request_data.error ||
          "Failed to add account"
      );
      console.error(
        "Payout account creation failed:",
        pageProps.createStorePayoutRequest?.request_data.error
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageProps.createStorePayoutRequest.request_status]);

  return (
    <>
      <Modal.Header closeButton>Verify information</Modal.Header>
      {errorMessage && (
        <AlertBanner
          message={errorMessage}
          type="error"
          closable={false}
          animated={true}
        />
      )}
      {successMessage && (
        <AlertBanner
          message={successMessage}
          type="success"
          closable={false}
          animated={true}
        />
      )}
      <Modal.Body>
        <div className="heading-help">
          By confirming the accuracy of your details, you can trust that your
          withdrawals are safe and secure on our platform
        </div>
        <Formik
          initialValues={storeFormInitValues}
          validationSchema={detailsValidationSchema}
          onSubmit={(values: any) => {
            let loggedAccountInfo: any =
              localStorage.getItem("mamiVendorXAuth") || "{}";
            loggedAccountInfo = JSON.parse(loggedAccountInfo);
            if (!loggedAccountInfo.selectedStore?.id) {
              console.error("Missing store ID, cannot submit payout account");
              setErrorMessage(
                "No store selected. Please select a store and try again."
              );
              return;
            }
            if (!loggedAccountInfo.userProfile?.id) {
              console.error("Missing user ID, cannot submit payout account");
              setErrorMessage(
                "User authentication error. Please log in again."
              );
              return;
            }
            if (payoutType !== "bank" && !cardtokenizedData?.token?.id) {
              setErrorMessage(
                "Missing card token. Please re-enter card details."
              );
              console.error("Missing card token:", cardtokenizedData);
              return;
            }
            let payload: any = {
              userId: loggedAccountInfo.userProfile.id,
              storeId: loggedAccountInfo.selectedStore.id,
              country: values.country,
              email: values.email,
              addressLine1: ownerAddressSearched?.label || values.addressLine1,
              city: values.city || storeFormInitValues?.ownerCity,
              state: values.state || storeFormInitValues?.ownerState,
              phone: `+${values.phone}`,
              name: `${values.firstName} ${values.lastName}`,
              postalCode:
                values.postalCode || storeFormInitValues?.ownerPostCode,
              firstName: values.firstName,
              lastName: values.lastName,
              externalAccountToken:
                payoutType === "bank"
                  ? tokenRequest.request_data.response
                  : cardtokenizedData?.token?.id,
              ip: ipAddress,
            };
            payload.accountHolderName =
              values.accountHolderName || storeFormInitValues.accountHolderName;
            setPayoutAccountData(payload);
            createPayoutAccAction({ pageProps, payload });
          }}
        >
          {(props: FormikProps<any>) => {
            const {
              values,
              touched,
              errors,
              setFieldTouched,
              handleChange,
              setFieldValue,
            } = props;
            return (
              <Form>
                <div className="form-wrap withdrawal-form">
                  <div className="">
                    <div className="two-sided">
                      <div className="form-group">
                        <label htmlFor="">First Name</label>
                        <Field
                          id="firstName"
                          value={values.firstName}
                          name="firstName"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.firstName && touched.firstName
                              ? "is-invalid-input "
                              : values.firstName !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="firstName"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="">Last Name</label>
                        <Field
                          id="lastName"
                          value={values.lastName}
                          name="lastName"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.lastName && touched.lastName
                              ? "is-invalid-input "
                              : values.lastName !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="lastName"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="two-sided">
                      <div className="form-group">
                        <label htmlFor="">Phone Number</label>
                        <PhoneInput
                          country={values.country}
                          enableTerritories={false}
                          enableSearch={true}
                          disableSearchIcon={true}
                          inputClass={`input-wrap ${
                            errors.phone && touched.phone
                              ? "is-invalid-input "
                              : values.phone !== ""
                              ? "valid-input"
                              : ""
                          }`}
                          value={values.phone}
                          onChange={(phone: string) => {
                            setFieldTouched("phone", true);
                            setFieldValue("phone", phone);
                          }}
                        />
                        <ErrorMessage
                          name="phone"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="">Email</label>
                        <Field
                          id="email"
                          value={values.email}
                          name="email"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.email && touched.email
                              ? "is-invalid-input "
                              : values.email !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="email"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="form-group address-wrap">
                      <label htmlFor="">Home address</label>
                      <GooglePlacesAutocomplete
                        selectProps={{
                          value: ownerAddressSearched,
                          onChange: (address) => {
                            setFieldValue("postalCode", "");
                            setFieldValue("addressLine1", address?.label || "");
                            setFieldValue("city", "");
                            setFieldValue("state", "");
                            setFieldValue("country", "");
                            handleSelectedOwnerAddress(address, setFieldValue);
                          },
                          placeholder: "Enter your home address",
                          openMenuOnClick: false,
                          classNamePrefix: "store-address-select",
                          noOptionsMessage: () => "Type a valid address",
                        }}
                        debounce={500}
                        onLoadFailed={() => {
                          console.error("Google Places API load failed");
                          return "Unable to suggest address";
                        }}
                        autocompletionRequest={{
                          componentRestrictions: { country: "ca" },
                        }}
                        apiKey={appConstants.GOOGLE_MAP_KEY}
                      />
                    </div>
                    <div className="two-sided">
                      <div className="form-group">
                        <label htmlFor="">City</label>
                        <Field
                          id="city"
                          value={values.city || storeFormInitValues?.city}
                          name="city"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.city && touched.city
                              ? "is-invalid-input "
                              : values.city !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="city"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="">State</label>
                        <Field
                          id="state"
                          value={values.state || storeFormInitValues?.state}
                          name="state"
                          type="text"
                          placeholder="State"
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.state && touched.state
                              ? "is-invalid-input "
                              : values.state !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="state"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                    </div>
                    <div className="two-sided">
                      <div className="form-group">
                        <label htmlFor="">Postal Code</label>
                        <Field
                          id="postalCode"
                          value={
                            values.postalCode || storeFormInitValues?.postalCode
                          }
                          name="postalCode"
                          type="text"
                          placeholder=""
                          onChange={(e: any) => {
                            setFieldValue("postalCode", e.target.value.trim());
                            if (e.target.value.trim().length >= 5) {
                              setNewPostalCode(e.target.value.trim());
                            }
                          }}
                          className={`input-wrap ${
                            errors.postalCode && touched.postalCode
                              ? "is-invalid-input "
                              : values.postalCode !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="postalCode"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="">Country</label>
                        <Field
                          id="country"
                          value={values.country || storeFormInitValues?.country}
                          name="country"
                          type="text"
                          placeholder=""
                          onChange={handleChange}
                          className={`input-wrap ${
                            errors.country && touched.country
                              ? "is-invalid-input "
                              : values.country !== ""
                              ? "valid-input"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          name="country"
                          className="form-input-error"
                          component="div"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {pageProps.createStorePayoutRequest.request_status ===
                  "CREATE_PAYOUT_ACCOUNT_FAILURE" && (
                  <AlertMsg
                    type="error"
                    message={
                      pageProps.createStorePayoutRequest?.request_data.error
                    }
                  />
                )}
                <div className="payout-cta sided">
                  <button
                    type="button"
                    disabled={
                      pageProps.createStorePayoutRequest?.is_request_processing
                    }
                    onClick={() => {
                      createTokenizeData({ pageProps, payload: "CLEAR" });
                      setCardTokenized("");
                    }}
                    className={
                      pageProps.createStorePayoutRequest.is_request_processing
                        ? "btn btn-disabled alt-btn"
                        : "btn alt-btn"
                    }
                  >
                    <img src={LeftArrow} alt="" /> Go Back
                  </button>
                  <button
                    type="submit"
                    disabled={
                      pageProps.createStorePayoutRequest?.is_request_processing
                    }
                    className={
                      pageProps.createStorePayoutRequest.is_request_processing
                        ? "btn btn-disabled"
                        : "btn"
                    }
                  >
                    {pageProps.createStorePayoutRequest.is_request_processing
                      ? "Please wait..."
                      : "Add withdrawal method"}
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </>
  );
};

export default VerifyInfo;
